export default {
  title: 'Crear un plan',
  subtitle: 'Empieza con un plan en blanco o deja que una plantilla complete las fechas y el presupuesto por ti.',
  templates: 'Empezar desde una plantilla',
  loadingTemplates: 'Cargando plantillas desde el reporte del modelo...',
  close: 'Cerrar',
  choosePeriod: 'Elige el período para "{option}".',
  startMonth: 'Mes de inicio',
  endMonth: 'Mes de fin',
  startDate: 'Fecha de inicio',
  endDate: 'Fecha de fin',
  selectedPeriod: 'Período seleccionado',
  pickStart: 'Elige el inicio',
  pickEnd: 'elige el fin',
  back: 'Atrás',
  continue: 'Continuar'
}
